import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const getByCpf = async (cpf: string, tipoBusca?: number) => {
  let url = `${API_CONSTANT_MAP.pessoa}/cpf/${cpf}`;
  if (tipoBusca !== undefined) {
    url += `?tipoBusca=${tipoBusca}`;
  }
  return requestApi.get(url);
};